export const selectColorList = [
    {
        key: 'red',
        value: '#F04C59',
    },
    {
        key: 'orange',
        value: '#F3943F',
    },
    {
        key: 'yellow',
        value: '#EADE3E',
    },
    {
        key: 'green',
        value: '#70D65C',
    },

    {
        key: 'blue',
        value: '#5A84F2',
    },
    {
        key: 'purple',
        value: '#B663E8',
    },
    // {
    //     key: 'pink',
    //     value: '#FA64C8'
    // }
];
